import axios from 'axios'

const GENERIC_AXIOS_STATUS_MESSAGE = /^Request failed with status code \d+$/

/** HTTP status from a thunk `rejectWithValue` axios-like payload (RTK unwrap uses the same shape). */
export function getRejectedThunkHttpStatus (payload: unknown): number | undefined {
  if (!axios.isAxiosError(payload)) {
    const legacy = payload as { response?: { status?: number } } | undefined
    return legacy?.response?.status
  }
  return payload.response?.status
}

function extractServerMessage (payload: unknown): string | undefined {
  if (axios.isAxiosError(payload)) {
    const data = payload.response?.data as unknown
    if (typeof data === 'string' && data.trim() !== '') return data.trim()
    if (data != null && typeof data === 'object') {
      const rec = data as Record<string, unknown>
      if (typeof rec.message === 'string' && rec.message.trim() !== '') return rec.message.trim()
      if (typeof rec.error === 'string' && rec.error.trim() !== '') return rec.error.trim()
    }
    if (
      payload.message != null &&
      payload.message !== 'Network Error' &&
      !GENERIC_AXIOS_STATUS_MESSAGE.test(payload.message)
    ) {
      return payload.message
    }
  }
  return undefined
}

/**
 * User-facing copy for failed public survey GET/PATCH (invalid tenant token, missing distribution, etc.).
 * Prefer backend body message when present (stable contract per BE spec).
 */
export function formatPublicSurveyHttpError (payload: unknown): string {
  const status = getRejectedThunkHttpStatus(payload)
  const raw = extractServerMessage(payload)

  if (status === 400) {
    return raw ?? 'This survey link is invalid or could not be opened. Request a new link from your instructor.'
  }
  if (status === 404) {
    return raw ?? 'This survey could not be found. It may have been removed or the link may be incorrect.'
  }
  return raw ?? 'Something went wrong. Please try again later.'
}
